import React, { Component } from 'react';
import { Link, withRouter,useLocation } from 'react-router-dom';
import { Collapse, Dropdown } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { AiFillPieChart } from "react-icons/ai";
import {TbCloudBolt} from 'react-icons/tb';
import {PiUserFocusLight} from 'react-icons/pi';
import {GoSignOut} from 'react-icons/go';
import WindowDimensions from '../hooks/useWindowDimensions';


class Sidebar extends Component {

  state = {};
  

  //  location= useLocation()

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true}); 
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      console.log(this.props.location)
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({[i]: false});
    });

    const dropdownPaths = [
      {path:'/', state: 'appsMenuOpen'},
      {path:'/', state: 'basicUiMenuOpen'},
      {path:'/', state: 'formElementsMenuOpen'},
      {path:'/', state: 'tablesMenuOpen'},
      {path:'/', state: 'iconsMenuOpen'},
      {path:'/', state: 'chartsMenuOpen'},
      {path:'/', state: 'userPagesMenuOpen'},
      {path:'/', state: 'errorPagesMenuOpen'},
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({[obj.state] : true})
      }
    }));
 
  }

  render () {
    return (

      <nav className="sidebar sidebar-offcanvas bg-white" id="sidebar" >
       
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top bg-white">
          <a className="sidebar-brand brand-logo"  ><img src={require('../../assets/images/logo.png')} alt="logo" style={{height:"100px"}} /></a>
          <a className="sidebar-brand brand-logo-mini"><img src={require('../../assets/images/logo.png')} alt="logos" style={{height:"92px",width:"100px"}}  /></a>
        </div>
        <ul className={"nav mt-5 navMedia"} style={{position:"fixed"}}>
          
          <li className="nav-item nav-category ">
          </li>
          
          <li className={ this.isPathActive('/basic-ui') ? 'nav-item menu-items ' : 'nav-item menu-items' }>
            <div className={ this.state.basicUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('basicUiMenuOpen') } data-toggle="collapse">
              <span className="menu-icon" onClick={this.openSidebar}>
              <AiFillPieChart className="chart-icon icon" />
              </span>
              <span className="menu-title"><Trans>Process Engine</Trans></span>
              {/* <i className="menu-arrow"></i> */}
            </div>
            <Collapse in={ this.state.basicUiMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu menu-title left-border">
                  <li className="nav-item"> <Link className={ this.isPathActive('/') ? 'nav-link active' : 'nav-link' } to="/"><Trans>Dashboards</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/basic-ui/dropdowns') ? 'nav-link active' : 'nav-link' } to="/"><Trans>Jobs</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/basic-ui/typography') ? 'nav-link active' : 'nav-link' } to="/"><Trans>Transformations</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/basic-ui/typography') ? 'nav-link active' : 'nav-link' } to="/"><Trans>Configuration</Trans></Link></li>
                
                </ul>
              </div>
            </Collapse>
          </li>
          <li className={ this.isPathActive('/form-elements') ? 'nav-item menu-items ' : 'nav-item menu-items' }>
            <div className={ this.state.formElementsMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('formElementsMenuOpen') } data-toggle="collapse">
              <span className="menu-icon" onClick={this.openSidebar}>
              <TbCloudBolt className="chart-icon icon" />
              </span>
              <span className="menu-title"><Trans>DQ Workflow</Trans></span>
              {/* <i className="menu-arrow"></i> */}
          
            </div>
            <Collapse in={ this.state.formElementsMenuOpen }>
             
              <div>
                <ul className="nav flex-column sub-menu left-border">
                  <li className="nav-item"> <Link className={ this.isPathActive('/form-elements/basic-elements') ? 'nav-link active' : 'nav-link' } to=""><Trans>Favourite Workflow</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('') ? 'nav-link ' : 'nav-link' } to=""><Trans>Standard Workflow</Trans></Link></li>
                  <li className="nav-item"> <Link  to="/Dashboard" className={ this.isPathActive('/Dashboard') ? 'nav-link active' : 'nav-link' } ><Trans>Custom Workflow</Trans></Link></li>
                  <li className="nav-item"> <Link  to="/summary" className={ this.isPathActive('/summary') ? 'nav-link active' : 'nav-link' } ><Trans>Summary level</Trans></Link></li>
                  <li className="nav-item"> <Link  to="/detail" className={ this.isPathActive('/detail') ? 'nav-link active' : 'nav-link' } ><Trans>Detail Level</Trans></Link></li>
              
                </ul>
              </div>
            </Collapse>
          </li>
        <li className={ this.isPathActive('/') ? 'nav-item menu-items ' : 'nav-item menu-items' }>
            <Link className="nav-link" to="/">
              <span className="menu-icon"> <PiUserFocusLight className="chart-icon icon" /></span>
              <span className="menu-title"><Trans>KYC Verfification</Trans></span>
            </Link>
          </li>
            <li className={ this.isPathActive('/') ? 'nav-item menu-items ' : 'nav-item menu-items' }>
            <Link className="nav-link" to="/">
              <span className="menu-icon"><GoSignOut className="chart-icon icon " /></span>
              <span className="menu-title"><Trans>Sign Out</Trans></span>
            </Link>
          </li>
          {/* <li className="nav-item menu-items">
            <a className="nav-link" href="http://bootstrapdash.com/demo/corona-react-free/documentation/documentation.html" rel="noopener noreferrer" target="_blank">
              <span className="menu-icon">
                <i className="mdi mdi-file-document-box"></i>
              </span>
              <span className="menu-title"><Trans>Documentation</Trans></span>
            </a>
          </li> */}
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname==path;
  }

  openSidebar(){
     document.body.classList.toggle('mobile-icon-only')
          document.body.classList.toggle('sidebar-icon-only')
          document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
          el.classList.remove('hover-open');
          })
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
         
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}

export default withRouter(Sidebar);